import script from "./Live2dPuppet.vue?vue&type=script&setup=true&lang=js"
export * from "./Live2dPuppet.vue?vue&type=script&setup=true&lang=js"

import "./Live2dPuppet.vue?vue&type=style&index=0&id=3b9ec6d7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b9ec6d7"]])

export default __exports__